import { CommonFieldContainer } from "@src/components/fields/containers";
import { type FC, type PropsWithChildren, type ReactNode } from "react";
import styled, { css } from "styled-components";

import DisplayComponent, { type DisplayComponentProps } from "./DisplayComponent";

interface DisplayWrapperProps {
    $type?: DisplayComponentProps["type"];
}

export const DisplayWrapper = styled.div<DisplayWrapperProps>`
    display: flex;
    align-items: center;
    height: 34px;
    ${({ $type }) =>
        $type === "checkbox" &&
        css`
            margin-left: -12px;
        `}
`;

interface ShowFieldProps extends DisplayComponentProps {
    label: string | ReactNode;
}

export const ShowField: FC<PropsWithChildren<ShowFieldProps>> = ({ label, type, value }) => {
    return (
        <CommonFieldContainer label={label}>
            <DisplayWrapper $type={type}>
                <DisplayComponent type={type} value={value} />
            </DisplayWrapper>
        </CommonFieldContainer>
    );
};
